<template>
  <div class="p-grid">
    <div class="p-col-12 p-pt-1 p-pb-1">
      <h2>{{ $t('admin.title') }}</h2>
      <div class="irinox-form admin-form">
        <TabView class="irinox-tab-big" lazy v-model:activeIndex="activeIndex">
          <TabPanel>
            <template #header>
              <span class="tab-header" data-index="0">
                <span class="tab-header__label">{{ $t('admin.tab_users') }}</span>
              </span>
            </template>
            <Users />
          </TabPanel>
          <TabPanel v-if="showPlans">
            <template #header>
              <div class="p-d-flex p-ai-center p-ml-3 p-mr-1">
                <div class="" style="line-height: 1;">{{ $t('admin.tab_plans') }}</div>
              </div>
            </template>
            <Plans :plans="plans"/>
          </TabPanel>
          <TabPanel v-if="showInvoices" :header="$t('admin.tab_billing')">
            <Invoices :invoices="invoices"/>
          </TabPanel>
        </TabView>
      </div>
    </div>
  </div>

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />

</template>

<script>
import Users from './Users.vue';
import Plans from './Plans.vue';
import Invoices from './Invoices.vue'
import PaymentService from '../../service/PaymentService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    Users,
    Plans,
    Invoices,
    IrinoxDialogDark
  },
  data() {
    return {
      activeIndex: 0,
      plans: [],
      appliances: [],
      invoices: [],
      dialog: {
        error: false,
      }
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      }),
      showPlans() {
        return this.plans?.length > 0;
      },
      showInvoices() {
        return this.invoices?.length > 0;
      }
  },
  created() {
    this.paymentService = new PaymentService();
    
    let tab = this.$route.query.tab;
    if(tab=='services') {
      this.activeIndex = 1;
    } else if(tab=='invoices') {
      this.activeIndex = 2;
    }
  },
  mounted() {
    this.getPlans();
    this.getInvoices();
  },
  methods: {
    getPlans() {
      this.paymentService.getPlans(this.personaltoken)
        .then((data) => {
          // console.log("PLANS ", data);
          if (data.code == "200") {
            this.plans = data.body;
          } else {
            console.error(JSON.stringify(data));
            this.plans = [];
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.plans = [];
          this.dialog.error = true;
        });
    },
    getInvoices() {
      this.paymentService.getInvoices(this.personaltoken)
        .then((data) => {
          // console.log("INVOICES ", data);
          if (data.code == "200") {
            this.invoices = data.body;
          } else {
            console.error(JSON.stringify(data));
            this.invoices = [];
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.invoices = [];
          this.dialog.error = true;
        });
    },

  }
}
</script>